import { useEffect } from "react";
import { waLink } from "@/lib/contact";

// Small redirect page: alwaysinsured.ca/whatsapp -> WhatsApp chat with prefill.
// Useful to share as a short, clean URL (business cards, IG bio, printed flyers).
export default function WhatsAppRedirect() {
  useEffect(() => {
    window.location.replace(waLink());
  }, []);

  return (
    <div className="min-h-screen bg-forest-900 flex items-center justify-center text-bone-100 text-center px-6">
      <div>
        <div className="font-serif text-3xl mb-4">Opening WhatsApp...</div>
        <p className="text-bone-100/70 mb-6">
          If nothing happens, tap the button below.
        </p>
        <a
          href={waLink()}
          className="inline-block bg-[#25D366] text-white px-6 py-3 rounded font-medium"
        >
          Open WhatsApp chat
        </a>
      </div>
    </div>
  );
}
